import axios from "axios";
import demoData from "@/mocks/demoData.json"; // Statische Demo-Daten
import dayjs from "dayjs";
import { store } from '../store'; // Falls du den Store nutzt, sonst entfernen

const apiClient = axios.create({
  baseURL: process.env.VUE_APP_AXIOS,
});

// Klon der Mock-Daten
const tempStorage = JSON.parse(JSON.stringify(demoData));

/** URL-spezifische Offset-Konfiguration */
const urlOffsets = {
    "/api/v1/dashboard/": { min: 0, max: -2, randomTime: true, fixDate: false },
    "default": { min: -2, max: -5, randomTime: true, fixDate: false },
    "/api/v1/plants/105/get_data_for_overview/": { min: 0, max: 0, randomTime: true, fixDate: false },
    "/api/v1/plants/25/get_data_for_overview/": { min: 0, max: 0, randomTime: true, fixDate: false },
    "/api/v1/plants/103/get_data_for_overview/": { min: 0, max: 0, randomTime: true, fixDate: false },
    "/api/v1/plants/22/get_data_for_overview/": { min: 0, max: 0, randomTime: true, fixDate: false },
    "/api/v1/plants/157/get_data_for_overview/": { min: 0, max: 0, randomTime: true, fixDate: false },
    "/api/v1/plants/20/get_data_for_overview/": { min: 0, max: 0, randomTime: true, fixDate: false },
    "/api/v1/plants/28/get_data_for_overview/": { min: 0, max: 0, randomTime: true, fixDate: false },
    "/api/v1/plants/23/get_data_for_overview/": { min: 0, max: 0, randomTime: true, fixDate: false },
    "/api/v1/plants/25/": { min: 0, max: 0, randomTime: false, fixDate: false },
    "/api/v1/plants/103/": { min: 0, max: 0, randomTime: false, fixDate: false },
    "/api/v1/plants/22/": { min: 0, max: 0, randomTime: false, fixDate: false },
    "/api/v1/plants/157/": { min: 0, max: 0, randomTime: false, fixDate: false },
    "/api/v1/plants/179/": { min: 0, max: 0, randomTime: false, fixDate: false },
    "/api/v1/plants/105/": { min: 0, max: 0, randomTime: false, fixDate: false },
    "/api/v1/plants/88/": { min: 0, max: 0, randomTime: false, fixDate: false },
    "/api/v1/plants/20/": { min: 0, max: 0, randomTime: false, fixDate: false },
    "/api/v1/plants/28/": { min: 0, max: 0, randomTime: false, fixDate: false },
    "/api/v1/plants/23/": { min: 0, max: 0, randomTime: false, fixDate: false },
    "/api/v1/organisations/1/get_research_data/": { min: 0, max: 0, randomTime: false, fixDate: false, keepTime: true },
    "/api/v1/plants/25/get_plant_journal/": { min: 0, max: 0, randomTime: false, fixDate: false, keepTime: true },
    "/api/v1/plants/25/get_alarmmessages_for_plant/": { min: 0, max: 0, randomTime: false, fixDate: false, keepTime: true },
    "/api/v1/report_users/": { min: 0, max: 0, randomTime: false, fixDate: false, keepTime: false },
    "/api/v1/usergroup/": { min: 0, max: 0, randomTime: false, fixDate: false, keepTime: false },
    "/api/v1/usergroup/1/": { min: 0, max: 0, randomTime: false, fixDate: false, keepTime: false },
    "/api/v1/usergroup/2/": { min: 0, max: 0, randomTime: false, fixDate: false, keepTime: false },
    "/api/v1/usergroup/3/": { min: 0, max: 0, randomTime: false, fixDate: false, keepTime: false },
    "/api/v1/organisations/43/43/get_daily_report/": { min: 0, max: 0, randomTime: false, fixDate: true, keepTime: false },
};

const blacklist = ['status_data', 'recent_data_hours', 'data'];

/** Gibt Offset-Infos für die URL zurück */
function getOffsetForUrl(url) {
    let offsetConfig = urlOffsets[url];

    // Falls keine exakte Übereinstimmung, versuche Pattern-Matching für dynamische URLs
    if (offsetConfig === undefined) {
        for (const [pattern, config] of Object.entries(urlOffsets)) {
            if (pattern !== "default" && url.includes(pattern.replace(/\/\d+\//g, '/'))) {
                offsetConfig = config;
                break;
            }
        }
    }

    // Fallback auf default
    if (offsetConfig === undefined) {
        offsetConfig = urlOffsets["default"];
    }

    let daysOffset = 0;
    let randomTime = false;
    let fixDate = false;
    let keepTime = false;

    if (typeof offsetConfig === "number") {
        daysOffset = offsetConfig;
    } else if (typeof offsetConfig === "object") {
        daysOffset = Math.floor(Math.random() * (offsetConfig.max - offsetConfig.min + 1)) + offsetConfig.min;
        console.log('daysOffset', daysOffset)
        randomTime = offsetConfig.randomTime || false;
        fixDate = offsetConfig.fixDate || false;
        keepTime = offsetConfig.keepTime || false;
        console.log('fixDate: ', fixDate)
        console.log('keepTime: ', keepTime)
    }

    return { daysOffset, randomTime, fixDate, keepTime };
}

function isLikelyDate(value) {
    return dayjs(value).isValid() && dayjs(value).year() > 2000;
}

function isWhitelisted(key) {
    if (blacklist.includes(key)) {
        return false; // explizit ignorieren
    }
    return /(timestamp|time|date|at)/i.test(key);
}

function adjustTimestamps(obj, daysOffset = 0, randomTime = false, fixDate = false, keepTime = false) {
    if (Array.isArray(obj)) {
        return obj.map(item => adjustTimestamps(item, daysOffset, randomTime, fixDate, keepTime));
    } else if (typeof obj === "object" && obj !== null) {
        const newObj = {};
        for (const key in obj) {
            if (Object.hasOwnProperty.call(obj, key)) {
                const val = obj[key];
                if (typeof val === "string" && isWhitelisted(key) && isLikelyDate(val)) {
                    let date;
                    if (fixDate){
                        date = dayjs(val).add(daysOffset, 'day');
                        console.log('date: ', date)
                    } else if (keepTime) {
                        // Nur Datum auf heute setzen, Uhrzeit beibehalten
                        const originalDate = dayjs(val);
                        const today = dayjs().add(daysOffset, 'day');
                        date = today
                            .hour(originalDate.hour())
                            .minute(originalDate.minute())
                            .second(originalDate.second())
                            .millisecond(originalDate.millisecond());
                    } else {
                        date = dayjs().add(daysOffset, 'day');
                    }
                    if (randomTime) {
                        const randomHours = Math.floor(Math.random() * 24);
                        const randomMinutes = Math.floor(Math.random() * 60);
                        date = date.add(randomHours, 'hour').add(randomMinutes, 'minute');
                    }
                    // keine Zukunft erlauben
                    if (date.isAfter(dayjs())) {
                        date = dayjs();
                    }
                    newObj[key] = date.toISOString();
                } else if (typeof val === "object") {
                    newObj[key] = adjustTimestamps(val, daysOffset, randomTime, fixDate, keepTime);
                } else {
                    newObj[key] = val;
                }
            }
        }
        return newObj;
    }
    return obj;
}

// Axios Interceptor
apiClient.interceptors.request.use((config) => {
    const isDemoUser = localStorage.getItem("isDemoUser") === "true";
    if (!isDemoUser) {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.common['Authorization'] = "Token " + token;
        }
        return config; // Normaler API-Call
    }

    // DEMO-MODUS: Verwende Mock-Daten + Zeitverschiebung
    return {
        ...config,
        adapter: () => {
            return new Promise((resolve) => {
                const { method, url, data } = config;
                const { daysOffset, randomTime, fixDate, keepTime } = getOffsetForUrl(url);

                console.log(`[Demo] ${method.toUpperCase()} ${url} | Offset: ${daysOffset} Tage | Random Time: ${randomTime} | fixDate: ${fixDate} | keepTime: ${keepTime}`);

                let responseData = tempStorage[url] || {};

                if (["get", "post", "patch"].includes(method)) {
                    responseData = adjustTimestamps(responseData, daysOffset, randomTime, fixDate, keepTime);
                    console.log('responseData apiClient mockData', responseData)
                }

                if (method === "get") {
                    resolve({ data: responseData });
                } 
                else if (method === "post") {
                    resolve({
                        data: responseData,
                        status: 200,
                        statusText: "OK",
                        headers: {},
                        config,
                        request: {},
                    });
                } 
                else if (method === "patch") {
                    const id = data.id;
                    if (tempStorage[url]) {
                        const index = tempStorage[url].findIndex(item => item.id === id);
                        if (index !== -1) {
                            tempStorage[url][index] = { ...tempStorage[url][index], ...data };
                            const patchedData = adjustTimestamps(tempStorage[url][index], daysOffset, randomTime, fixDate, keepTime);
                            resolve({ data: patchedData });
                        } else {
                            resolve({ data: {}, status: 404 });
                        }
                    }
                } 
                else if (method === "delete") {
                    if (tempStorage[url]) {
                        tempStorage[url] = tempStorage[url].filter(item => item.id !== data.id);
                        resolve({ data: { success: true } });
                    } else {
                        resolve({ data: { success: false }, status: 404 });
                    }
                }
            });
        }
    };
});

export default apiClient;
